import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-custom-page-2',
    templateUrl: './custom-page-2.component.html',
    styleUrls: ['./custom-page-2.component.scss'],
})
export class CustomPage2Component implements OnInit {

        constructor(
        ) {
            
        }


            ngOnInit(): void { {
            }
}
}